import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, mapTo, catchError } from 'rxjs/operators';
import { MessageServiceService } from './message-service.service';
import { CampaignRes } from '../models/campaign.model';
//import { Tokens } from '../models/auth.model';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  private readonly LOGGED_USER_INFO = 'LOGGED_USER_INFO';
  private readonly LOGGED_USER_CRMID = 'LOGGED_USER_CRMID';
  private loggedUser: string;
  isLogged$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private messageService: MessageServiceService) {
    if(localStorage.getItem("username"))
    {
        this.isLogged$.next(true);
    }

   }

  // login(user: { username: string, password: string }): Observable<boolean> {
  //   return this.http.post<any>(environment.apiUrl+'UserAuthentication/authenticate' , user)
  //     .pipe(
  //       tap(tokens => this.doLoginUser(user.username, tokens)),
  //       mapTo(true),
  //       catchError(error => {
  //         this.messageService.showError();
  //         return of(false);
  //       }));  
  // }


  login(user: any) {
    return this.http.post<any>(environment.apiUrl + 'UserAuthentication/authenticate/', user);
  }

  getOtp(emailID:string){
   // return this.http.get<string>(environment.apiUrl + 'UserManagement/SendResetPasswordOTPEmail',email);
    return this.http.get(`${environment.apiUrl}UserManagement/SendResetPasswordOTPEmail?emailID=${emailID}`);
  }

  verifyOtp(payload: { emailID: string; Otp: string }) {
    return this.http.get(`${environment.apiUrl}UserManagement/VerifyOTP`, { 
      params: { 
        emailID: payload.emailID, 
        Otp: payload.Otp 
      } 
    });
  }
  updatePassword(UserId:Number,CurrentPassword:String,Password:String){
    //debugger;
    return this.http.post<CampaignRes>(`${environment.apiUrl}UserManagement/UpdatePassword?UserId=${UserId}&CurrentPassword=${CurrentPassword}&Password=${Password}`,'');
  }

  doLoginUser(username: string, tokens) {
    this.loggedUser = username;
    this.storeTokens(tokens);
    this.storeUserData(tokens);
  }

  private storeTokens(tokens) {
    localStorage.setItem(this.JWT_TOKEN, tokens.response.token);
    localStorage.setItem(this.REFRESH_TOKEN, tokens.response.refreshTokens[0].token);
    localStorage.setItem(this.LOGGED_USER_CRMID, tokens.response.refreshTokens[0].userId);
  }

  private storeUserData(tokens) {
    localStorage.setItem(this.LOGGED_USER_INFO, JSON.stringify(tokens.response.loginUserDetails));
  }

  isLoggedIn() {

    return !!this.getJwtToken();
  }

  getJwtToken() {
    // debugger
    let hcToken = localStorage.getItem("HC_JWT_TOKEN");
    if (hcToken && hcToken != null) {
      return hcToken;
    } else {
      return localStorage.getItem(this.JWT_TOKEN);
    }
  }

  refreshToken() {
    return this.http.post<any>(environment.apiUrl + 'UserAuthentication/authenticate', {
      'refreshToken': this.getRefreshToken()
    }).pipe(tap((tokens) => {
      this.storeJwtToken(tokens.response.result.token);
    }));
  }

  private getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }

  private storeJwtToken(jwt: string) {
    localStorage.setItem(this.JWT_TOKEN, jwt);
  }

  removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
  }
}
